/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { useBackgroundStyle } from '../../utils/styles/background'
import { useGridStyle } from '../../utils/styles/grid'
import { useScrollStyle } from '../../utils/styles/scroll'

export const Grid = ({ className, children, ...props }) => {
  const style = css`
    ${useGridStyle({ direction: 'row', ...props })}
    ${useScrollStyle(props)}
    ${useBackgroundStyle(props)}
    ${props.style}
  `

  return (
    <div className={`grid ${className}`} css={style}>
      {children}
    </div>
  )
}

export const Col = ({ children, ...props }) => {
  const style = css`
    ${useGridStyle(props)}
    ${useScrollStyle(props)}
    ${useBackgroundStyle(props)}
  `

  return (
    <div className="col" css={style} {...props}>
      {children}
    </div>
  )
}
